var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",style:('height:'+_vm.containerHeight+'px')},[(_vm.url)?_c('iframe',{ref:"iframe",staticClass:"iframe",attrs:{"src":_vm.url,"allowfullscreen":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }